import { render, staticRenderFns } from "./NumberCounter.vue?vue&type=template&id=6e2fd320&scoped=true"
import script from "./NumberCounter.vue?vue&type=script&lang=js"
export * from "./NumberCounter.vue?vue&type=script&lang=js"
import style0 from "./NumberCounter.vue?vue&type=style&index=0&id=6e2fd320&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2fd320",
  null
  
)

export default component.exports